<template>
  <div>
    <markdown-it-vue class="md-body" :content="content" />
  </div>
</template>

<script>
import MarkdownItVue from 'markdown-it-vue'
import 'markdown-it-vue/dist/markdown-it-vue.css'

export default {
  name: 'MarkdownText',
  components: {
    MarkdownItVue
  },
  props: {
    content: String
  }
}
</script>

<style lang="scss">
@import "@/assets/main.scss";

.md-body .markdown-body {
  font-family: $font-family, sans-serif !important;;
}
</style>